import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import DashboardLayout from '../Layout/DashboardLayout';

const ProtectedRoute = () => {
  // Always call hooks at the top level
  const auth = useAuth();
  const location = useLocation();
  
  const isAuthenticated = auth?.isAuthenticated || false;
  const isLoading = auth?.isLoading || false;

  // If authentication is still loading, show a spinner
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="spinner"></div>
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If authenticated, render the child routes within the dashboard layout
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
};

export default ProtectedRoute;
